import { HttpInterceptors } from "./http.interceptor";

export class ProductClassService extends HttpInterceptors {
	async listProductClass (filters) {
		const response = await this.axios.get("productClass/listProductClass", { params: { filters } });
		return response.data;
	}

	async upsertProductClass (payload) {
		const response = await this.axios.post("productClass/upsertProductClass", payload);
		return response.data;
	}

	async deleteProductClass (id) {
		const response = await this.axios.delete("productClass/deleteProductClass", { params: id });
		return response.data;
	}
}
